import { getData } from '@/utils/http'
import config from '@/config'
export default {
    namespaced: true,
    state: {
        tableLoading: true,
        tableList: [],
        name: '',
        carNo: '',
        projectId:"",
        pageIndex: 1,
        total: 0
    },
    mutations: {
        CHANGE_TABLE_LOADING(state, tableLoading) {
            state.tableLoading = tableLoading
        },
        CHANGE_TABLE_DATA(state, changeData) {
            state.tableList = changeData.data.rows
            state.total = changeData.total
        },
        CHANGE_CUSTOMER_TABLE_DATA(state, changeData) {
            state.customerTableList = changeData.data
            state.total = changeData.total ?? 0
        },
        CHANGE_SEARCH_COLL(state, changeData) {
            if (changeData['changeKey'] == 'orgId' && typeof changeData['data'] != 'object') {
                state[changeData['changeKey']] = [changeData['data']]
            } else {
                state[changeData['changeKey']] = changeData['data']
            }
        },
        CHANGE_TABLE_INDEX(state, value) {
            state.pageIndex = value
        }
    },
    actions: {
        //获取列表
        getList({ commit, state }, deptId) {
            return new Promise(resolve => {
                getData(`logistics/driver/car/bind/page`, {
                    name: state.name,
                    carNo: state.carNo,
                    page: 1,
                    size: config.pageSize,
                    projectId:state.projectId,
                    deptId:deptId
                }).then(res => {
                    if (res.state == 1) {
                        commit('CHANGE_TABLE_DATA', res)
                        resolve({
                            state: 1,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg
                        })
                    }
                })
            })
        },
        //写入查询条件
        setSearchData({ commit }, changeData) {
            commit('CHANGE_SEARCH_COLL', changeData)
        },
        //修改分页
        setPageIndex({ commit }, value) {
            commit('CHANGE_TABLE_INDEX', value)
        },
        //修改添加loading
        changeListLoading({ commit }, value) {
            commit('CHANGE_TABLE_LOADING', value)
        }
    }
}
